
<template>
  <VDropdown ref="dropdown">
    <VTooltip :disabled="!isLogged">
      <button class="userButton">
        <img v-if="isLogged" class="userInfoImage" :src="avatarUrl" alt="">
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-opacity=".77" stroke-width="2" d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/></svg>
      </button>
      <template #popper>
        <div class="userRolesTooltip">
          <div class="userRolesTooltip__title">Текущие роли</div>
          <ul v-if="userRoles.length" class="userRolesTooltip__list">
            <li v-for="role in userRoles" :key="role" class="userRolesTooltip__item">{{ role }}</li>
          </ul>
          <div v-else class="userRolesTooltip__empty">Роли не назначены</div>
        </div>
      </template>
    </VTooltip>
    <template #popper>
      <UserMenu @closeMenu="closeMenuHandler">
      </UserMenu>
    </template>
  </VDropdown>
</template>

<script>
import {Dropdown as VDropdown, Tooltip as VTooltip} from "floating-vue";
import UserMenu from "@/components/UserMenu/UserMenu.vue";
import {computed, useTemplateRef} from "vue";
import {useAuthStore} from "@/store/auth";
import {useSettingsStore} from "@/store/settings";
import avatarFallback from "@/assets/img/Avatar.png";

export default {
  name: "MainHeaderUserButton",
  components: {UserMenu, VDropdown, VTooltip},
  setup() {
    const authStore = useAuthStore();
    const settingsStore = useSettingsStore();
    const dropdown = useTemplateRef('dropdown');

    const isLogged = computed(() => {
      return authStore.userId;
    })
    const avatarUrl = computed(() => settingsStore.user.img_url || avatarFallback);
    const userRoles = computed(() => settingsStore.userRoles || []);
    function closeMenuHandler() {
      dropdown.value?.hide()
    }
    return {isLogged, avatarUrl, userRoles, closeMenuHandler}
  }
}
</script>


<style scoped lang="scss">
.userButton {
  width: 52px;
  height: 52px;
  background-color: var(--cd-bg);
  border: #1DC336 solid 1px;
  border-radius: 50%;
  cursor: pointer;
  margin: auto 0;
  padding: 0;
  color: var(--cd-text);
  overflow: hidden;
}

.userInfoImage {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}
</style>

<!-- Стили тултипа: popper телепортируется в body, поэтому без scoped -->
<style lang="scss">
.userRolesTooltip {
  text-align: left;

  &__title {
    font-size: 12px;
    opacity: 0.75;
    margin-bottom: 4px;
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__item {
    font-size: 14px;
  }

  &__empty {
    font-size: 14px;
  }
}
</style>
